var map = {
	"./icon-01.png": "9poR",
	"./icon-02.png": "zeqT",
	"./icon-03.png": "tvSU",
	"./icon-04.png": "lN6P"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Wtd1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/four-pillars ^\.\/.*$
// module id = Wtd1
// module chunks = 1